import { apiRequest } from "./util";

function sendOneEmail(data) {
  return apiRequest("oneTimeEmailApi", "POST", data);
}

export default { sendOneEmail };
